export type RunwayAnalysisComponentSource = 'CLAYRIO' | 'USER_DEFINED';

export enum RunwayStatus {
  MONTHS = 'MONTHS',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  INFINITE = 'INFINITE',
}

export interface RunwayAnalysisComponentDto {
  id: string;
  label: string;
  source?: RunwayAnalysisComponentSource;
  rowData: Record<string, number | null>;
}

export interface RunwayAnalysisRowDto {
  key: string;
  metricLabel: string;
  rowData: Record<string, number | null>;
  components?: RunwayAnalysisComponentDto[];
}

export interface AdjustedEbitdaParamsDto {
  netRevenueWeight: number;
  marketingSpendWeight: number;
  otherOpexWeight: number;
}

export interface UpdateAdjustedEbitdaParamsPayload {
  netRevenueWeight: number;
  marketingSpendWeight: number;
}

export type RunwayAnalysisSourceMetric = string;

export interface RunwayAnalysisComponentPayload {
  metric: RunwayAnalysisSourceMetric;
  name: string;
  rowData: Record<string, number>;
  sourceComponentId?: string | null;
}

export type AddRunwayAnalysisComponentPayload = RunwayAnalysisComponentPayload;

export interface RunwayAnalysisComponentListItemDto {
  id: string;
  name: string;
  metric: string;
  source?: RunwayAnalysisComponentSource;
}

export interface RunwayAnalysisComponentsListDto {
  components: RunwayAnalysisComponentListItemDto[];
}

export interface GetRunwayAnalysisComponentsParams {
  dueDiligenceId: string;
  metric?: string[];
  excludeMetric?: string[];
}

export interface EditRunwayAnalysisComponentResponse {
  id: string;
}

export interface RunwayAnalysisDto {
  months: string[];
  rows: RunwayAnalysisRowDto[];
  adjustedEbitdaParams?: AdjustedEbitdaParamsDto | null;
  liquidity?: number | null;
  burnRate?: number | null;
  runwayMonths?: number | null;
  adjustedEbitda?: number | null;
  currency: string | null;
  runwayStatus: RunwayStatus;
  reportingEntity?: string | null;
  asOfDate?: string | null;
}
